(function () {
  var root = document.querySelector('[data-authority-application]');

  if (!root) {
    return;
  }

  var form = root.querySelector('[data-authority-application-form]');
  var endpoint = root.getAttribute('data-application-endpoint') || '';
  var siteKey = root.getAttribute('data-turnstile-site-key') || '';
  var errorMessage = form.querySelector('[data-abp-client-error]');
  var submitButton = form.querySelector('button[type="submit"]');
  var originalButtonLabel = submitButton.textContent;
  var widgetId;
  var pending = null;
  var busy = false;
  var verificationTimer = null;

  function isUuidV7(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  function validEndpoint(value) {
    if (!value) {
      return '';
    }

    try {
      var url = new URL(value, window.location.origin);

      if (url.protocol !== 'https:' && url.protocol !== 'http:') {
        return '';
      }

      return url.href;
    } catch (error) {
      return '';
    }
  }

  function setError(visible) {
    errorMessage.hidden = !visible;
  }

  function setBusy(nextBusy) {
    busy = nextBusy;
    submitButton.disabled = nextBusy;
    submitButton.textContent = nextBusy ? 'Submitting…' : originalButtonLabel;
  }

  function resetVerification() {
    if (
      typeof widgetId !== 'undefined' &&
      window.turnstile &&
      typeof window.turnstile.reset === 'function'
    ) {
      window.turnstile.reset(widgetId);
    }
  }

  function clearVerificationWatchdog() {
    if (verificationTimer !== null) {
      window.clearTimeout(verificationTimer);
      verificationTimer = null;
    }
  }

  function startVerificationWatchdog() {
    clearVerificationWatchdog();
    // Turnstile does not guarantee a callback; never leave the form locked.
    verificationTimer = window.setTimeout(function () {
      verificationTimer = null;

      if (!pending) {
        return;
      }

      failPending();
      resetVerification();
    }, 12000);
  }

  function failPending() {
    clearVerificationWatchdog();
    pending = null;
    setError(true);
    setBusy(false);
  }

  function submissionPayload(context, token) {
    return {
      abp_lead_id: context.leadId,
      name: form.elements.name.value.trim(),
      email: form.elements.email.value.trim(),
      phone: form.elements.phone.value.trim(),
      customer_profile: form.elements.customer_profile.value,
      book_and_timing: form.elements.book_and_timing.value.trim(),
      price_acknowledged: form.elements.price_acknowledged.checked,
      contact_consent: form.elements.contact_consent.checked,
      turnstile_token: token,
      attribution: context.attribution || {},
      is_synthetic: Boolean(context.isSynthetic)
    };
  }

  function sendApplication(payload) {
    var target = validEndpoint(endpoint);

    if (!target) {
      return Promise.reject(new Error('Application service is not configured.'));
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) {
        controller.abort();
      }
    }, 15000);

    return fetch(target, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Application service rejected the request.');
      }

      return response.json();
    }).then(function (result) {
      var responseLeadId = String(result && result.abp_lead_id || '');

      if (
        !result ||
        result.accepted !== true ||
        result.delivery_accepted !== true ||
        !isUuidV7(responseLeadId) ||
        responseLeadId !== payload.abp_lead_id
      ) {
        throw new Error('Application service returned a partial response.');
      }

      return { leadId: responseLeadId };
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function deliverPending(token) {
    clearVerificationWatchdog();

    if (!pending || !token) {
      failPending();
      resetVerification();
      return;
    }

    var acceptedSubmission = pending;
    var payload = submissionPayload(acceptedSubmission.context, token);

    sendApplication(payload).then(function (accepted) {
      var bridge = window.AuthorityBookApplication;

      if (
        !bridge ||
        typeof bridge.acceptApplication !== 'function' ||
        bridge.acceptApplication({
          leadId: accepted.leadId,
          name: payload.name,
          email: payload.email
        }) !== true
      ) {
        throw new Error('Application acceptance could not be finalized.');
      }

      pending = null;
      setError(false);
    }).catch(function () {
      pending = null;
      setError(true);
      resetVerification();
    }).finally(function () {
      clearVerificationWatchdog();
      setBusy(false);
    });
  }

  function initializeTurnstile() {
    if (typeof widgetId !== 'undefined') {
      return true;
    }

    if (
      !siteKey ||
      !window.turnstile ||
      typeof window.turnstile.render !== 'function'
    ) {
      return false;
    }

    var container = form.querySelector('[data-application-turnstile]');

    try {
      widgetId = window.turnstile.render(container, {
        sitekey: siteKey,
        action: 'authority_book_application',
        appearance: 'interaction-only',
        execution: 'execute',
        callback: deliverPending,
        'expired-callback': function () {
          failPending();
          resetVerification();
        },
        'error-callback': function () {
          failPending();
        }
      });
    } catch (error) {
      widgetId = undefined;
      return false;
    }

    return typeof widgetId !== 'undefined';
  }

  form.addEventListener('input', function () {
    setError(false);
  });
  form.addEventListener('change', function () {
    setError(false);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (busy) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var bridge = window.AuthorityBookApplication;

    if (
      !bridge ||
      typeof bridge.getSubmissionContext !== 'function' ||
      !validEndpoint(endpoint) ||
      !initializeTurnstile() ||
      !window.turnstile ||
      typeof window.turnstile.execute !== 'function'
    ) {
      setError(true);
      return;
    }

    var context = bridge.getSubmissionContext();

    if (!context || !isUuidV7(context.leadId)) {
      setError(true);
      return;
    }

    pending = { context: context };
    setError(false);
    setBusy(true);

    try {
      startVerificationWatchdog();
      window.turnstile.execute(widgetId);
    } catch (error) {
      failPending();
    }
  });
})();
